import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./App.min.css";
import { Routes, Route } from 'react-router-dom';
import StartPage from './views/StartPage';
import StartTestPage from './views/StartTestPage';
import ScenariosPage from './views/ScenariosPage';
import TestPage from './views/TestPage';

function App() {
  return (
      <Routes>
        <Route path="/" element={<StartPage />} />
        <Route path="/start-test" element={<StartTestPage />} />
        <Route path="/test" element={<TestPage />} />
        <Route path="/scenarios" element={<ScenariosPage />} />
        <Route path="*" element={<StartPage />} />
      </Routes>

  );
}

export default App;